import { useEffect, useState } from 'react'

import { confirmEmail } from '@client/services/confirmEmail'

import useQuery from '@hooks/useQuery'

export default function useCallConfirmEmail(contact) {
  const queryParams = useQuery()
  const [emailIsChecked, setEmailIsChecked] = useState(false)

  async function callConfirmEmail(leadToken) {
    try {
      const { status } = await confirmEmail(leadToken)
      if (status === 200) {
        setEmailIsChecked(true)
      }
    } catch (error) {
      console.log(error)
    }
  }

  function checkCallConfirmEmail() {
    const leadToken = queryParams.get('leadToken')
    const shouldConfirmEmail = queryParams.get('confirmEmail')
    if (shouldConfirmEmail && leadToken) {
      callConfirmEmail(leadToken)
    }
  }

  useEffect(() => {
    checkCallConfirmEmail()
  }, [contact])

  return {
    emailIsChecked,
  }
}
